<template>
    <div class="email-recipient d-flex gap-1 align-items-start">
        <the-input
            v-model="localRecipient.email"
            class="mb-0"
            placeholder="E-mail"
            :text="localRecipient.email"
            :readonly="userEmail === localRecipient.email"
            :invalid="invalid"
            :invalid-feedback="invalid ? 'Niepoprawny adres e-mail' : ''"
            :invalid-icon="false"
            @change="invalid = !isEmailFormat"
        />

        <div class="email-recipient__buttons">
            <the-btn
                text="Zapisz"
                class="btn-secondary"
                :disabled="!isRecipientChanged || !isEmailFormat"
                @click.native.stop.prevent="onRecipientSave"
            >
                <a-icon
                    v-if="saveLoading"
                    width="16"
                    height="16"
                    icon="Spinner"
                />
            </the-btn>

            <the-btn
                class="btn-danger"
                @click.native.stop.prevent="onRecipientDelete"
            >
                <a-icon
                    width="16"
                    height="16"
                    :icon="deleteLoading ? 'Spinner' : 'Bin'"
                />
            </the-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecipientEmail',

    data() {
        return {
            saveLoading: false,
            deleteLoading: false,
            localRecipient: null,
            invalid: false
        }
    },

    props: {
        recipient: {
            type: Object,
            required: true
        },

        merchant: {
            type: Object,
            required: true
        },

        initialState: {
            type: Array,
            required: false
        },

        fetchRecipients: {
            type: Function,
            required: true
        },

        idx: {
            type: Number,
            default: undefined
        }
    },

    computed: {
        isRecipientChanged() {
            if (!this.initialState || !this.localRecipient.email) return false

            if (this.idx === undefined) {
                return true
            }

            const initialRecipient = this.initialState.find(
                merchant => merchant.id === this.merchant.id
            ).recipients[this.idx]

            if (!initialRecipient) {
                return true
            } else {
                return this.localRecipient.email !== initialRecipient.email
            }
        },

        isEmailFormat() {
            // eslint-disable-next-line
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return regex.test(this.localRecipient.email)
        },

        userEmail() {
            return this.$store.getters.getUser.email
        }
    },

    methods: {
        async onRecipientSave() {
            let res
            let notification

            this.saveLoading = true
            const { email, id, merchant_id } = this.localRecipient

            if (id) {
                res = await this.$store.dispatch('updateMailRecipient', {
                    id,
                    email
                })

                if (res) {
                    notification =
                        'Pomyślnie edytowano odbiorcę do powiadomień e-mail o promocjach'
                }
            } else {
                res = await this.$store.dispatch('saveMailRecipient', {
                    merchant_id,
                    email
                })

                if (res) {
                    notification =
                        'Pomyślnie dodano odbiorcę do powiadomień e-mail o promocjach'
                }
            }

            this.$store.dispatch('addNotification', {
                type: notification ? 'success' : 'danger',
                content: notification || 'Wystąpił błąd'
            })

            await this.fetchRecipients()

            if (!id) {
                this.$emit('clear-new-recipient')
            }
            this.saveLoading = false
        },

        async onRecipientDelete() {
            const id = this.localRecipient.id

            if (!id) {
                this.$emit('clear-new-recipient')
                return
            }

            this.deleteLoading = true

            const res = await this.$store.dispatch('deleteMailRecipient', {
                id
            })

            this.$store.dispatch('addNotification', {
                type: res ? 'success' : 'danger',
                content: res
                    ? 'Pomyślnie usunięto odbiorcę z listy e-mail o promocjach'
                    : 'Wystąpił błąd'
            })

            this.fetchRecipients()
            this.deleteLoading = false
        }
    },

    created() {
        this.localRecipient = this.recipient
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.email-recipient {
    flex-wrap: wrap;

    &__buttons {
        display: flex;
        gap: 1rem;
    }

    .btn {
        height: 50px !important;
    }

    .form-input {
        width: 375px;
        max-width: 100%;
    }

    > * {
        max-width: 100%;
    }

    @include media-breakpoint-down(sm) {
        + .email-recipient {
            border-top: 1px solid var(--color-gray-200);
            padding-top: 1rem;
        }
    }
}
</style>
